import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>Mumbai Pav Recipe Helper - Created with ♥</p>
    </footer>
  );
}

export default Footer;